module.exports = __webpack_public_path__ + "img/b3-4.2c1f468.png";